import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { handleSignOut } from '../../helpers/global';

type Props = {
  // eslint-disable-next-line react/require-default-props
  errorMessage?: string;
  description?: string;
  logOut?: boolean;
};

function Error({ errorMessage, description, logOut = true }: Props) {
  return (
    <div className="error-message">
      <Typography variant="h1" className="center">
        {errorMessage || 'An unexpected error occured'}
      </Typography>
      <Typography variant="body1" className="center">
        {description ||
          'Please refresh the page and try again. If the error persists, you can reach out to us directly or get in touch through the help icon below.'}
      </Typography>
      {logOut && (
        <Button
          variant="outlined"
          onClick={handleSignOut}
          sx={{ margin: 'auto' }}>
          Log Out
        </Button>
      )}
    </div>
  );
}

export default Error;
